import type { ScholarshipPlayer } from '../../../../types/scholarships';

/**
 * The player record a roster row opens, or null when it has none to open.
 *
 * A row attached from the player list carries its `prospectId`; a row added by hand has none, and a
 * row flagged `prospectMissing` points at a record since merged away or deleted. Every roster view
 * asks this one question, so a name opens the same thing on the Players tab, the depth chart and
 * the pitching staff.
 */
export const openableProspectId = (
  player: Pick<ScholarshipPlayer, 'prospectId' | 'prospectMissing'>,
): string | null => (player.prospectId != null && !player.prospectMissing ? player.prospectId : null);

/** What a click on this row does, said the same way on every view: open the player, or edit the row. */
export const rowActionLabel = (
  player: Pick<ScholarshipPlayer, 'prospectId' | 'prospectMissing'>,
  name: string,
): string => (openableProspectId(player) ? `View details for ${name}` : `Edit ${name}`);
